import WeeklyMeeting from './WeeklyMeeting';

export default WeeklyMeeting;
